import React, { FormEvent, useState } from "react"
import { useDispatch } from "react-redux"

import Input from "../../../shared/input"
import { getUserId } from "../../../services/helper"
import { prevStep, setCompanyId } from "../../../redux/inscription"
import { setLoading } from "../../../redux/loading"
import CompanyApi from "../../../services/api/Company.api"
import EmployeeApi from "../../../services/api/Employee.api"
import MessageError from "../../../shared/message.error"

const CreateCompany = () => {
  const dispatch = useDispatch()

  const [name, setName] = useState<string>("")
  const [corporateName, setCorporateName] = useState<string>("")
  const [address1, setAddress1] = useState<string>("")
  const [postalCode, setPostalCode] = useState<string>("")
  const [city, setCity] = useState<string>("")
  const [error, setError] = useState<string>("")

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError("")

    try {
      dispatch(setLoading(true))
      const company = await new CompanyApi().create({
        name,
        corporateName,
        address1,
        postalCode,
        city
      })
      await new EmployeeApi().createOne(getUserId(), company.id)
      dispatch(setCompanyId(company.id))
    } catch (err) {
      setError(err.message)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <div className="form">
      <form onSubmit={onSubmit} className="field">
        <Input
          value={name}
          onChange={setName}
          type="text"
          label="Nom de votre organisation"
          minLength={2}
          required
          focus
        />
        <Input
          value={corporateName}
          onChange={setCorporateName}
          type="text"
          label="Raison sociale"
        />
        <Input
          value={address1}
          onChange={setAddress1}
          type="text"
          label="Adresse"
        />
        <Input
          value={postalCode}
          onChange={setPostalCode}
          type="text"
          label="Code postal"
        />
        <Input value={city} onChange={setCity} type="text" label="Ville" />
        <MessageError message={error} />
        <div className="buttons is-centered field">
          <button
            type="button"
            className="button is-dark"
            onClick={e => {
              e.preventDefault()
              dispatch(prevStep())
            }}
          >
            Retour
          </button>
          <button type="submit" className="button is-primary">
            Créer
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreateCompany
